import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';

export const fetchMarkImageApi = (storage_path, patent_id) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/image/mark/fetch`,
        method: 'POST',
        data: {
            storage_path,
            patent_id,
            lab_check: false,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
};

export const getPatentFullImagesApi = (patentId) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/image/full-images`,
        method: 'GET',
        params: {
            patentId,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
};

export const getSignImageApi = (data) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/image/sign`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
};

export const getTextRelatedImgApi = ({ text, code, tab, patent_id, lang }) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/image/related-img`,
        method: 'POST',
        data: {
            text,
            code,
            tab,
            patent_id,
        },
        params: {
            lang
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
};


export const getImageOcrInfoApi = ({ img_id, patent_id }) => {
    return psHttp({
        cache: true,
        url: `${coreSearchApiUrlPrefix}/patent/image/image-ocr`,
        method: 'POST',
        uuid: `${patent_id}__${img_id}`,
        data: {
            img_id,
            patent_id
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
};
